import { Container } from 'inversify';

/**
 * Creates a new inversify container
 */
export function InversifyContainerFactory(): Container {
  return new Container();
}
